const common = () => {

  const body = document.querySelector('body'),
    bodyWrap = document.querySelector('#body-wrap'),
    //utilityBar = body.querySelector('#utility-bar'),
    //primaryNav = body.querySelector('ul#menu-primary-navigation'),
    //primaryNavWrap = body.querySelector('.menu-primary-navigation-container'),
    header = body.querySelector('header.banner'),
    pageHeader = body.querySelector('.page-header'),
    faqs = body.querySelectorAll('.schema-faq-section'),
    searchToggle = body.querySelector('button.header-search.desktop'),
    searchForm = body.querySelector('#hermd-search-wrap-desktop'),
    //searchToggleMobile = body.querySelector('button.header-search.mobile'),
    searchItemMobile = body.querySelector('.mobile-search-item'),
    //searchToggle = body.querySelector('#search-toggle'),
    //searchForm = body.querySelector('.search-form'),
    
  /*   mobileMenu = body.querySelector('#mobile-menu'),
    mobileMenuWrap = body.querySelector('#p13-mobile-menu-wrap'),
    modalSearch = body.querySelector('.search-form-wrapper'),
    modalOverlaySearch = body.querySelector('#search-modal'),
    modalCloseSearch = body.querySelector('#search-close'), */
    categoryFilter = body.querySelector('#cat-filter'),
    scrollTriggers = body.querySelectorAll('.scroll-trigger'),
    //galleries = body.querySelectorAll('.wp-block-gallery'),
    backTop = body.querySelector('#back-to-top'),
    sliders = body.querySelectorAll('.hermd-slider-wrap'),
    parallaxEl = document.querySelector('.banner-image.parallax'),
    //expandos = document.querySelectorAll('.line-height-effect'),
    schedulingModal = document.querySelector('#scheduling-modal'),
    schedulingModalClose = document.querySelector('#scheduling-modal-close'),
    schedulingModalTriggers = document.querySelectorAll('.scheduling-modal-trigger'),
    //portalModal = document.querySelector('#portal-modal'),
    //portalModalClose = document.querySelector('#portal-modal-close'),
    //portalModalTriggers = document.querySelectorAll('#patient-portal, .header-portal-trigger'),
    //headerPortalTrigger = document.querySelectorAll('#header-portal-trigger'),
    accordionToggles = body.querySelectorAll('.p13-accordion-wrap');

    var homeVideo = document.querySelector('#home-video'),
        bannerImage = body.querySelector('.banner-image'),
        alertBar = body.querySelector('#alert-bar'),
        adminBar = body.querySelector('#wpadminbar'),
        imageLoaded = false,
        adminHeight = !adminBar ? 0 : adminBar.clientHeight,
        domLoaded = false,
        xDown,
        yDown;

  if(searchToggle && searchForm) {
    searchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      if(body.classList.contains('search-open')) {
        body.classList.remove('search-open');
      } else {
        body.classList.add('search-open');
        searchForm.querySelector('input[type=search]').focus();
        // close mega menu if open
        const openMegaToggles = document.querySelectorAll('button.mega-toggle.open');
        if(openMegaToggles.length) {
          openMegaToggles.forEach(function(togg) {
            togg.parentElement.querySelector('.subnav-wrap').style.height = '0';
            togg.classList.remove('open');
          })
        }
      }
    });
  }
  if(searchItemMobile) {
    searchItemMobile.querySelector(' input[type=search]').addEventListener('input', function() {
      searchItemMobile.classList.add('active');
    });
  }
  /*  if(searchToggleMobile && searchFormMobile) {
    searchToggleMobile.addEventListener('click', function(e) {
      e.preventDefault();
      if(body.classList.contains('mobile-search-open')) {
        body.classList.remove('mobile-search-open');
      } else {
        body.classList.add('mobile-search-open');
      }
    });
  } */

  document.documentElement.style.setProperty('--admin-height', `${adminHeight}px`);
  if(accordionToggles) {
    accordionToggles.forEach(function(toggleWrap) {
      var toggle = toggleWrap.querySelector('.accordion-toggle'),
          content = toggleWrap.querySelector('.accordion-content'),
          toggleParent = toggleWrap.parentNode,
          isSolo = toggleParent.classList.contains('accordion-solo') ? true : false;
      if(toggleWrap.classList.contains('open')) {
        content.style.height = content.clientHeight+'px';
      }
      
      toggle.addEventListener('click', function (e) {
        e.preventDefault();

        var contentHeight = content.querySelector('.inner').clientHeight,
        openAccordion =toggleParent.querySelector('.open');

        if(isSolo) {
          openAccordion.querySelector('.accordion-content').style.height = '0px';
          setTimeout(() => {
            openAccordion.classList.remove('open');
            toggleWrap.classList.add('open');
            content.style.height = contentHeight + 'px';
          }, 10);
        } else {
          if (toggleWrap.classList.contains('open')) {
            toggleWrap.classList.remove('open');
            content.style.height = '0px';
          } else {
            setTimeout(() => {
              toggleWrap.classList.add('open');
              content.style.height = contentHeight + 'px';
            }, 10);
          }
        }
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 510);
        
      
      })
    })
  }
    
  if(schedulingModal && schedulingModalClose) {
    if(schedulingModalTriggers) {
      schedulingModalTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          schedulingModal.classList.add('open');
          setTimeout(function() {
            schedulingModal.style.opacity = '1';
          }, 10);
        })
      })
    }
    schedulingModalClose.addEventListener('click', function() {
      schedulingModal.style.opacity = '0';
      setTimeout(function() {
        schedulingModal.classList.remove('open');
      }, 1000);
    });
  }

/*   if(portalModal && portalModalClose) {
    if(portalModalTriggers) {
      portalModalTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          portalModal.classList.add('open');
          setTimeout(function() {
            portalModal.style.opacity = '1';
            portalModal.addEventListener('click', function(e) {
              if(e.target ==portalModal) {
                portalModal.style.opacity = '0';
                setTimeout(function() {
                  portalModal.classList.remove('open');
                }, 1000);
              }
            })
          }, 10);
        })
      });
      portalModalClose.addEventListener('click', function() {
        portalModal.style.opacity = '0';
        setTimeout(function() {
          portalModal.classList.remove('open');
        }, 1000);
      });
    }
  } */
  window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  var isMobile = window.mobileCheck(),
      scrolling1 = true;

  function navToSlide(slider, slideNum, dots = false, dot = false) {
    var slidePosition = slider.querySelector('.slide-'+slideNum).offsetLeft,
        currentSlide = slider.querySelector('.current'),
        slidesCount = slider.querySelectorAll('li').length;
    slider.style.left = '-'+slidePosition+'px';
    if(currentSlide) {
      currentSlide.classList.remove('current');
    }
    if(dots) {
      var currentDot = dots.querySelector('.current'),
      dotsCount = dots.querySelectorAll('button').length;
      if(currentDot) {
        currentDot.classList.remove('current');
      }
      dot.classList.add('current');
      slider.querySelector('.slide-'+slideNum).classList.add('current');
      if(dot.dataset.slide == dotsCount) {
        slider.parentElement.querySelector('button.next').classList.add('hid');
        slider.parentElement.querySelector('button.prev').classList.remove('hid');
      }
    } else {
      slider.querySelector('.slide-'+slideNum).classList.add('current');
      /*   */
    }
    if((slidesCount - 1) <= slideNum) {
      slider.closest('.hermd-slider-wrap').querySelector('button.next').classList.add('hid');
    } else {
      slider.closest('.hermd-slider-wrap').querySelector('button.next').classList.remove('hid');
    }
    if(slideNum == 1) {
      slider.closest('.hermd-slider-wrap').querySelector('button.prev').classList.add('hid');
    } else {
      slider.closest('.hermd-slider-wrap').querySelector('button.prev').classList.remove('hid');
    }
  }
/* 
  function getTouches(evt) {
    return evt.touches ||             // browser API
      evt.originalEvent.touches; // jQuery
  }

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  } */

  function doSliders(initiated) {
    //var slidesPerView = window.innerWidth > 992 ? 3 : 2,
    var slideHeights = [],
        slideHeight = 0;
    if(sliders) {
      sliders.forEach(function(sliderWrap) {
        if(isMobile) {
          sliderWrap.classList.add('mobile-slider');
        }
        const slider = sliderWrap.querySelector('ul'),
              next = sliderWrap.querySelector('button.next'),
              prev = sliderWrap.querySelector('button.prev'),
              dots = sliderWrap.querySelector('.slider-dots'),
              slides = slider.querySelectorAll('li');
        var sliderWidth = 0,
            slideWidth = 0,
            sliderPos = 0,
            sliderMargin = 350,
            slidesPerView = sliderWrap.hasAttribute('data-slides-per-view') ? parseInt(sliderWrap.dataset.slidesPerView) : 4,
            slidesOffset = sliderWrap.hasAttribute('data-slide-offset') ? parseInt(sliderWrap.dataset.slideOffset) : 1,
            thisSlider = sliderWrap.dataset.slider;
        if(window.innerWidth < 992) {
          sliderMargin = 0;
          slidesPerView = sliderWrap.hasAttribute('data-slides-per-view-mobile') ? parseInt(sliderWrap.dataset.slidesPerViewMobile) : 3;
        }
        document.documentElement.style.setProperty(`--slide-height-${thisSlider}`, 'auto');
        if(slides.length > (parseInt(slidesPerView)-parseInt(slidesOffset))) {
          next.classList.remove('hid');
          if(dots) {
            dots.classList.remove('hid');
          }
        } else {
          sliderWrap.classList.add('static');
        }
        var n = 0;
        slides.forEach(function(slide) {
          // console.log(slide);
          
          n++;
          sliderWidth += slide.clientWidth+80;
          if(thisSlider == 'plans') {
            slide.style.width = (((sliderWrap.clientWidth-sliderMargin)/slidesPerView))+'px';
          } else {
            slide.style.width = (((sliderWrap.clientWidth)/slidesPerView))+'px';
          }
          
          slide.classList.add('loaded');
          slideWidth = slide.clientWidth;
          
          slideHeights.push(slide.clientHeight);
          //console.log(slider);
          if(!initiated) {
            if(n == 1) {
              slide.classList.add('current');
            }
          }
          if(dots) {
            if(!initiated) {
              const dot = document.createElement('button');
              dot.classList.add('slider-dot');
              if(n == 1) {
                dot.classList.add('current');
              }
              dot.setAttribute('data-slide', n);
              dots.appendChild(dot);
              dot.addEventListener('click', function() {
                //console.log(dot.dataset.slide);
                navToSlide(slider, dot.dataset.slide, dots, dot);
              });
            }
          }
        });

        slideHeight = Math.max(...slideHeights);
        document.documentElement.style.setProperty(`--slide-height-${thisSlider}`, `${slideHeight}px`);
        if(slides.length >= (slidesPerView-1)) {
          slider.style.width = (sliderWidth)+'px';
        }

        if(!initiated) {
          next.addEventListener('click', function() {
            var nextSlide = parseInt(slider.querySelector('li.current').dataset.slide)+1;
            // console.log(nextSlide);
            var theDot = false,
                theDots = false;
            if(dots) {
              theDot = sliderWrap.querySelector(`button.slider-dot[data-slide="${nextSlide}"]`);
              theDots = dots;
            }
            navToSlide(slider, nextSlide, theDots, theDot);
          });
          prev.addEventListener('click', function() { // need to get current slider left pos and calc from there b'c of dots
            var prevSlide = parseInt(slider.querySelector('li.current').dataset.slide)-1;
            if(dots) {
              navToSlide(slider, prevSlide, dots, sliderWrap.querySelector(`button.slider-dot[data-slide="${prevSlide}"]`));
            } else {
              navToSlide(slider, prevSlide);
            }
          });
        }

        if(isMobile) {
          // slider.addEventListener('touchstart', handleTouchStart, false);
          slider.addEventListener('touchmove', function(evt) {
            if (!xDown || !yDown) {
              return;
            }
            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;
            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;
            if (Math.abs(xDiff) > Math.abs(yDiff)) {
              if (xDiff > 0) {
                /* right swipe */
                if(sliderWidth > sliderPos+(slideWidth)) {
                  /*  sliderPos += slideWidth;
                  slider.style.left = '-'+sliderPos+'px'; */

                  var nextSlide = parseInt(slider.querySelector('li.current').dataset.slide)+1;
                  // console.log(nextSlide);
                    var theDot = false,
                        theDots = false;
                    if(dots) {
                      theDot = sliderWrap.querySelector(`button.slider-dot[data-slide="${nextSlide}"]`);
                      theDots = dots;
                    }
                    navToSlide(slider, nextSlide, theDots, theDot);


                }
              } else {
                /* left swipe */
              //  if(sliderPos > 0) {
                  var prevSlide = parseInt(slider.querySelector('li.current').dataset.slide)-1;
                  if(dots) {
                    navToSlide(slider, prevSlide, dots, sliderWrap.querySelector(`button.slider-dot[data-slide="${prevSlide}"]`));
                  } else {
                    navToSlide(slider, prevSlide);
                  }
            //     }


                /* if(sliderPos > 0) {
                  sliderPos -= slideWidth;
                  slider.style.left = '-'+sliderPos+'px';
                } */
              }
            }
            xDown = null;
            yDown = null;
          }, false);
          xDown = null;
          yDown = null;
        }
      })
    }
  }


  window.addEventListener('resize', function() {
    //consolehomeVideoSrc('resize');
    
  /*    if(window.innerWidth <= 992) {
      document.querySelector('body').classList.add('is-mobile');
    } else {
      document.querySelector('body').classList.remove('is-mobile');
    } */
    
    if(adminBar) {
      adminHeight = adminBar.clientHeight;
      document.documentElement.style.setProperty('--admin-height', `${adminHeight}px`);
    } else {
      adminHeight = 0;
      document.documentElement.style.setProperty('--admin-height', '0px');
    }
    setTimeout(function() {
      doSliders(true);
    }, 500);
  });

  setInterval( function() {
    if (scrolling1) {
      scrolling1 = false;
      scrollingStuff();
    }
  }, 25 );

  var //didScroll = false,
    winTop = window.pageYOffset,
    lastWinTop = 0,
    pageHeaderHeight = 120,
    headerTop = header.clientHeight,
    goingDown = true,
    alertHeight = 5,
    adminHeight = 0,
    focusedElementBeforeModalSearch,
    theMobileMenu,
    winWidth = body.clientWidth,
    adminBarHeight;

  function overlayFade() {
    const overlay = body.querySelector('#feat-loader-overlay');
    if(overlay) {
      setTimeout(function () {
        overlay.animate([
          { opacity:'1' },
          { opacity:'0' },
        ], {
          duration: 1000,
          iterations: 1,
        });
        setTimeout(function () {
          overlay.style.display = 'none';
        }, 1000);
      }, 300);
    }
    imageLoaded = true;
  }

  if(categoryFilter) {
    categoryFilter.addEventListener('change', function() {
      var theLink = this.value;
      window.location.href = theLink;
      return false;
    });
  }

  if (faqs) {
    faqs.forEach(function (faq) {
      const toggle = faq.querySelector('.schema-faq-question'),
        content = faq.querySelector('.schema-faq-answer');
      var theHeight;
      toggle.addEventListener('click', function () {
        if (!this.classList.contains('open')) {
          const theContent = content.innerHTML;
          content.innerHTML = content.classList.contains('opened') ? theContent : `<div class="the-content">${theContent}</div>`;
          content.classList.add('opened');
          setTimeout(() => {
            theHeight = content.querySelector('.the-content').clientHeight;
            toggle.classList.toggle('open');
            content.animate([
              { height:'0' },
              { height:`${theHeight}px` },
            ], {
              duration: 300,
              iterations: 1,
            });
            content.style.height = `${theHeight}px`;
          }, 20);
        } else {
          toggle.classList.toggle('open');
          theHeight = content.querySelector('.the-content').clientHeight;
          content.animate([
            { height:`${theHeight}px` },
            { height: '0px'},
          ], {
            duration: 300,
            iterations: 1,
          });
          content.style.height = '0px';
        }
      });
    });
  }

  if (pageHeader) {
    pageHeaderHeight = pageHeader.clientHeight;
    if (pageHeaderHeight < 120) {
      pageHeaderHeight = 120;
    }
  }

  function triggerScrolls(scrollTriggers, isScroll) {
    scrollTriggers.forEach(function (el) {
      const things = el.querySelectorAll('li');
      var elViewportOffset = el.getBoundingClientRect(),
          elTop = elViewportOffset.top,
          halfscreen = window.innerHeight / 3;
      // consolehomeVideoSrc('el.offsetTop = '+el.offsetTop+'  window.innerHeight / 2 = '+window.innerHeight / 3);
      if(!isScroll) {
        if (el.offsetTop > window.innerHeight/2 && el.offsetTop < window.innerHeight * 1.2) {
            setTimeout(function() { // if trigger is in viewport on pageload, delay the animation
              el.classList.add('in-viewport');
              if(things) {
                var n = 0;
                things.forEach(function(thing) {
                  n++;
                  setTimeout(() => {
                    thing.classList.add('triggered');
                  }, (n*125));
                  
                })
              }
            }, 1300);
        } //else {
      } else {

        if ((elTop + halfscreen) < window.innerHeight && elTop + (halfscreen * 1.5) > window.innerHeight) {
        //  if (!el.classList.contains('in-viewport')) {
          // if (el.offsetTop < window.innerHeight) {
          //    setTimeout(function() { // if trigger is in viewport on pageload, delay the animation
          //     el.classList.add('in-viewport');
          //   }, 1300);
          // } else {
              el.classList.add('in-viewport');
              if(things) {
                var n = 0;
                things.forEach(function(thing) {
                  n++;
                  setTimeout(() => {
                    thing.classList.add('triggered');
                  }, (n*125));
                  
                })
              }
            //}
        //  }
        } /* else {
          el.classList.remove('in-viewport');
        } */
      }
    })
  }

  function scrollingStuff() {
    winTop = window.pageYOffset;
    headerTop = header.clientHeight;

    var rate = winTop * 0.1;
    
    /*  if(expandos) {
      expandos.forEach(function(expando) {
        if(window.innerWidth > 992) {
          var expandoTop = expando.getBoundingClientRect().top,
          expandoOffset = expando.offsetTop;
          var lineHeight = (((winTop - expandoOffset)+600)/450);
          if(expandoTop < 600 && expandoTop > 140) {
            expando.style.lineHeight = lineHeight;
          }
        }
      })
    } */

    if(parallaxEl && window.innerWidth > 992) {
      parallaxEl.style.transform = 'translate3d(0px, '+rate+'px, 0px)';
    }

    if (winTop >= alertHeight) {
      body.classList.add('alert-scrolled');
      body.classList.add('has-scrolled');
      // header.classList.remove('absolute');
    } else {
      body.classList.remove('alert-scrolled');
      // header.classList.add('absolute');
    }

    if(backTop) {
      winTop > window.innerHeight ? backTop.classList.add('active') : backTop.classList.remove('active');
    }

    // header behavior

    if (winTop > headerTop) {
      body.classList.add('scrolt');
    } else {
      header.classList.remove('transition');
      body.classList.remove('scrolt');
    }

    if (winTop > lastWinTop) { // scolling down
      header.classList.remove('dropped');
      goingDown = true;
    } else { // scrolling up
      if (winTop > 300) {
        header.classList.add('dropped');
        header.classList.add('transition');
      }
      goingDown = false;
    }

    lastWinTop = winTop;
    //didScroll = true;
    //scroll-in effects
    if (scrollTriggers) {
      triggerScrolls(scrollTriggers, true);
    }
    /*  if(winWidth > 992) {
      setUtilityTop();
    } */
  }
  

  window.addEventListener('scroll', function () {

    scrolling1 = true;
  });

  window.addEventListener('load', function() {
    setTimeout(function() {
      if (scrollTriggers) {
        triggerScrolls(scrollTriggers, false);
      }
    }, 1000)
    
  });

  /* function navSwap() {
    var oldWinWidth = winWidth;
    winWidth = body.clientWidth;
    if (oldWinWidth <= 992 && winWidth > 992) {
      primaryNavWrap.innerHTML = primaryNav.outerHTML;
      //doMenuParents('desktop');
    }
  } */

  /* window.addEventListener('resize', function () {
    //setUtilityTop();
    navSwap();
  }); */
  function windowLoadStuff() {
    adminBar = body.querySelector('#wpadminbar');
    alertBar = body.querySelector('#alert-bar');
    if(adminBar) {
      adminHeight = adminBar.clientHeight;
      document.documentElement.style.setProperty('--admin-height', `${adminHeight}px`);
    } else {
      adminHeight = 0;
      document.documentElement.style.setProperty('--admin-height', '0px');
    }
    if (alertBar) {
      alertHeight = alertBar.clientHeight;
      document.documentElement.style.setProperty('--alert-height', `${alertHeight+adminHeight}px`);
    } else {
      document.documentElement.style.setProperty('--alert-height', `${adminHeight}px`);
    }

    doSliders(false);
    if(isMobile) {
      const footerNavToggles = document.querySelectorAll('.footer-nav-col h2');
      if(footerNavToggles) {
        footerNavToggles.forEach(function(togg) {
          togg.addEventListener('click', function() {
            if(togg.classList.contains('open')) {
              togg.parentElement.querySelector('ul').style.height = '0px';
              setTimeout(() => {
                togg.classList.remove('open');
              }, 10);
            } else {
              const items = togg.parentElement.querySelector('ul').querySelectorAll('li');
              var ulHeight = 0;
              if(items) {
                items.forEach(function(item) {
                  ulHeight += item.clientHeight;
                })
              }
              togg.parentElement.querySelector('ul').style.height = `${ulHeight}px`;
              setTimeout(() => {
                togg.classList.add('open');
              }, 10);
            }
          });
        })
      }
    }
    winWidth = body.clientWidth;
    homeVideo = document.querySelector('#the-home-video');
    bannerImage = document.querySelector('.banner-image');
    var videoLoaded = false,
        n = 0;
    
    if(bannerImage || homeVideo) {
      if(homeVideo && winWidth > 992) {
        //consolehomeVideoSrc('Video readystate: '+homeVideo.readyState);
        if(bannerImage) {
          bannerImage.remove();
        }
        var vidSrc = homeVideo.dataset.vidsrc;
        const homeVideoSrc = document.createElement('source');
        homeVideoSrc.setAttribute('src', vidSrc);
      /*   homeVideoSrc.setAttribute('preload', 'metadata');
        homeVideoSrc.setAttribute('autoplay', false);
        homeVideoSrc.setAttribute('loop', true);
        homeVideoSrc.setAttribute('muted', 'muted');
        homeVideoSrc.setAttribute('playsinline', true);
        homeVideoSrc.setAttribute('id', 'home-video'); */
        homeVideoSrc.setAttribute('type', 'video/mp4');
        homeVideo.appendChild(homeVideoSrc);
        /* if(vidPoster != '') {
          homeVideoSrc.setAttribute('poster', vidPoster);
        } */
        //homeVideo.appendChild(videoSrc);
        if(homeVideo.readyState == 4 || homeVideo.readyState == 3) {
          videoLoaded = true;
          overlayFade();
          homeVideo.muted = true;
          homeVideo.play();
        } else {
          const interval = setInterval(function () {
            if(homeVideo.readyState == 4 || homeVideo.readyState == 3) {
              videoLoaded = true;
              overlayFade();
              homeVideo.muted = true;
              homeVideo.play();
            }
            n++;
            //consolehomeVideoSrc(n);
            //consolehomeVideoSrc(homeVideo.readyState);
            
            if (videoLoaded) {
              clearInterval(interval);
            }
          }, 250);

        }
      } else {
        // homeVideo.remove();
        var featImage = new Image();
        featImage.src = bannerImage.dataset.imageSrc;
        featImage.onload = function () {
          overlayFade();
        };
        /* setTimeout(function() {
          // consolehomeVideoSrc(featImage.complete);
          
        }, 1000); */
      }
    }
    
    scrollingStuff();
    domLoaded = true;
  }

  window.onload = function () {
    if(!domLoaded) {
      windowLoadStuff();
    }
  }

  setTimeout(() => {
    if(!domLoaded) {
      windowLoadStuff();
    }
  }, 1000);

  if (backTop) {
    backTop.addEventListener('click', function() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    });
  }
/* 
// custom lightbox gallery - *images must be set to link top media file*
const wpBlockGalleries = document.querySelectorAll('.wp-block-gallery');

var stageCreated = false,
    sliderImage,
    sliderStage,
    sliderCaption,
    sliderNext,
    sliderPrev,
    sliderClose,
    currentGallery,
    currentSlide;
function createSliderStage(gallery) {
  currentGallery = gallery;
  sliderStage = document.createElement('div');
  sliderImage = document.createElement('div');
  sliderCaption = document.createElement('div');
  sliderNext = document.createElement('button');
  sliderPrev = document.createElement('button');
  sliderClose = document.createElement('button');
  sliderStage.setAttribute('id', 'p13-slider-stage');
  sliderImage.setAttribute('id', 'p13-slider-image');
  sliderCaption.setAttribute('id', 'p13-slider-caption');
  sliderNext.setAttribute('id', 'p13-slider-next');
  sliderPrev.setAttribute('id', 'p13-slider-prev');
  sliderClose.setAttribute('id', 'p13-slider-close');
  sliderClose.textContent = 'close modal slider';
  sliderPrev.textContent = 'previous slide';
  sliderNext.textContent = 'next slide';
  sliderStage.append(sliderClose);
  sliderStage.append(sliderImage);
  sliderImage.append(sliderCaption);
  sliderStage.append(sliderPrev);
  sliderStage.append(sliderNext);
  sliderCaption.addEventListener('click', function(e) {
    e.stopPropagation();
  });
  sliderNext.addEventListener('click', function(e) {
    e.stopPropagation();
    changeSlide('next');
  });
  sliderPrev.addEventListener('click', function(e) {
    e.stopPropagation();
    changeSlide('prev');
  });
  document.querySelector('body').append(sliderStage);
  stageCreated = true;
  sliderStage.addEventListener('click', function() {
    sliderStage.remove();
    stageCreated = false;
  })
  sliderImage.addEventListener('click', function(e) {
    e.stopPropagation();
  })
}

function changeSlide(dir) {
  console.log(dir);
  if(dir == 'next') {
    
    if(currentSlide == currentGallery.dataset.total) {
      getSlide(currentGallery.querySelector('[data-slide="1"]'));
    } else {
      getSlide(currentGallery.querySelector('[data-slide="'+(parseInt(currentSlide)+1)+'"]'));
    }
  }
  if(dir == 'prev') {
    if(currentSlide == 1) {
      getSlide(currentGallery.querySelector('[data-slide="'+(currentGallery.dataset.total)+'"]'));
    } else {
      getSlide(currentGallery.querySelector('[data-slide="'+(parseInt(currentSlide)-1)+'"]'));
    }
  }
}

function getSlide(slide) {
  currentSlide = slide.dataset.slide;
  sliderImage.innerHTML = '';
  sliderCaption.innerHTML = '';
  sliderImage.classList.add('loading');
  if(!slide.hasAttribute('data-img_src')) {
    var imgId = slide.querySelector('img').getAttribute('class');
    fetch('/wp-content/themes/neo-philanthropy/ajax/gallery-ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        slide: imgId,
        size: 'full-width',
      }),
    })
    .then(function (result) {
      return result.json();
    })
    .then(function (data) {
      if (data.length > 0) {
        //console.log(data);
        //var slideImage = new Image(),
        var slideImage = document.createElement('img'),
            slideCaption = slide.parentElement.querySelector('figcaption');
        slideImage.setAttribute('src', data[0]);
        slide.setAttribute('data-img_src', data[0]);
        slideImage.classList.add('slider-image');
        //slideImage.onload = function() {
        slideImage.setAttribute('width', data[1]);
        slideImage.setAttribute('height', data[2]);
        slide.setAttribute('data-width', data[1]);
        slide.setAttribute('data-height', data[2]);
        if(slideCaption != null) { 
          slideImage.setAttribute('alt', slideCaption.textContent);
        } else {
          slideImage.setAttribute('alt', '');
        }
        //sliderImage.style.width = data[1]+'px';
        sliderImage.style.width = 'auto';
        sliderImage.append(slideImage);
        setTimeout(() => {
          sliderImage.classList.remove('loading');
          sliderImage.style.width = slideImage.clientWidth+'px';
        }, 300);
        if(slideCaption) {
          sliderCaption.innerHTML = slideCaption.innerHTML;
          sliderImage.append(sliderCaption);
        }
      //  }
      }
    });
  } else {

    var slideImage = document.createElement('img'),
        slideCaption = slide.parentElement.querySelector('figcaption');
    slideImage.setAttribute('src', slide.dataset.img_src);
    slideImage.classList.add('slider-image');
    //slideImage.onload = function() {
    slideImage.setAttribute('width', slide.dataset.width);
    slideImage.setAttribute('height', slide.dataset.height);
    if(slideCaption != null) { 
      slideImage.setAttribute('alt', slideCaption.textContent);
    } else {
      slideImage.setAttribute('alt', '');
    }
    sliderImage.style.width = 'auto';
    sliderImage.append(slideImage);
    setTimeout(() => {
      sliderImage.classList.remove('loading');
      sliderImage.style.width = slideImage.clientWidth+'px';
    }, 300);
    if(slideCaption) {
      sliderCaption.innerHTML = slideCaption.innerHTML;
      sliderImage.append(sliderCaption);
    }

  }
}

if(wpBlockGalleries) {
  wpBlockGalleries.forEach(function(gallery) {
    const slides = gallery.querySelectorAll('.wp-block-image > a');
    if(slides.length) {
      gallery.classList.add('p13-lightbox-gallery');
      var i = 0;
      slides.forEach(function(slide) {
        if(slide.innerHTML != '') {
          i++;
          slide.classList.add('slide-'+i);
          slide.setAttribute('data-slide', i);
          slide.addEventListener('click', function(e) {
            e.preventDefault();
            if(!stageCreated) {
              createSliderStage(gallery);
            }
            currentSlide = slide.dataset.slide;
            getSlide(slide);
          })
        }
      })
      gallery.setAttribute('data-total', i);
    }
  })
}

//var isMobile = screen.orientation !== 'undefined' ? true : false;

function getTouches(evt) {
  return evt.touches ||        // browser API
    evt.originalEvent.touches; // jQuery
}

function handleTouchStart(evt) {
  const firstTouch = getTouches(evt)[0];
  xDown = firstTouch.clientX;
  yDown = firstTouch.clientY;
}

function handleTouchMove(evt) {
  if (!xDown || !yDown) {
    return;
  }

  var xUp = evt.touches[0].clientX;
  var yUp = evt.touches[0].clientY;

  var xDiff = xDown - xUp;
  var yDiff = yDown - yUp;

  if (Math.abs(xDiff) > Math.abs(yDiff)) {
    if (xDiff > 0) {
      // right swipe 
      if(evt.target.classList.contains('slider-image') || evt.target.getAttribute('id') == 'p13-slider-caption') {
        changeSlide('next');
      }
    } else {
      // left swipe 
      if(evt.target.classList.contains('slider-image') || evt.target.getAttribute('id') == 'p13-slider-caption') {
        changeSlide('prev');
      }
    }
  }
  xDown = null;
  yDown = null;
}

if(isMobile) {
  document.addEventListener('touchstart', handleTouchStart, false);
  document.addEventListener('touchmove', handleTouchMove, false);
  var xDown = null;
  var yDown = null;
}
 
 */

    // accordion toggle action for details block
    const detailsBlocks = document.querySelectorAll('.wp-block-details');
    if(detailsBlocks) {
      detailsBlocks.forEach(function(det) {
        const accordion = document.createElement('div');
           //   detContents = det.innerHTML;
              accordion.innerHTML=  det.innerHTML;
              accordion.classList.add('wp-block-details');
              accordion.style.height = det.querySelector('summary').clientHeight+'px';
              det.before(accordion);
              det.remove();
        const toggle = accordion.querySelector('summary');
        toggle.addEventListener('click', function() {
          if(accordion.classList.contains('open')) {
            accordion.style.height = (accordion.querySelector('summary').clientHeight+4)+'px';
            accordion.classList.remove('open');
          } else {
            accordion.style.height = toggle.clientHeight+'px';
            const kids = accordion.querySelectorAll('*');
            var detailsHeight = 0;
            kids.forEach(function(kid) {
              if(kid.parentElement == accordion) { // immediate children only
                var kidStyle = getComputedStyle(kid, null);
                detailsHeight += kid.clientHeight+parseInt(kidStyle.marginTop)+parseInt(kidStyle.marginBottom);
              }
            })
            accordion.style.height = detailsHeight+'px';
            accordion.classList.add('open');
          }
        });
      })
    }

/*   // vanilla js fitvids
  ;(function(window, document, undefined) {
    'use strict';
    
    // List of Video Vendors embeds you want to support
    var players = [
      'iframe[src*="youtube.com"]',
      'iframe[src*="vimeo.com"]'
    ];
    
    // Select videos
    var fitVids = document.querySelectorAll(players.join(','));
    
    // If there are videos on the page...
    if(fitVids.length) {
    
      // Loop through videos
      for(var i=0;i<fitVids.length;i++) {
    
        // Get Video Information
        var fitVid = fitVids[i];
        var width = fitVid.getAttribute('width');
        var height = fitVid.getAttribute('height');
        var aspectRatio = height/width;
        var parentDiv = fitVid.parentNode;
    
        // Wrap it in a DIV
        var div = document.createElement('div');
        div.className = 'fitVids-wrapper';
        div.style.paddingBottom = aspectRatio * 100 + "%";
        parentDiv.insertBefore( div, fitVid );
        fitVid.remove();
        div.appendChild( fitVid );
    
        // Clear height/width from fitVid
        fitVid.removeAttribute('height')
        fitVid.removeAttribute('width');
      }
    }
  })(window, document); */

}

export default common;